import { cn } from "@/lib/cn";

type Props = {
  count: number;
  /** Accent plein (compte fermé / boîte unifiée) vs soft (ligne dossier). */
  variant?: "solid" | "soft";
  className?: string;
  /** Cap d’affichage (défaut 99 → « 99+ »). */
  max?: number;
};

/**
 * Pastille non-lus — cercle vrai (1 chiffre), capsule ronde si 2+ / 99+.
 */
export function UnreadCountBadge({
  count,
  variant = "solid",
  className,
  max = 99,
}: Props) {
  if (count < 1) return null;

  const capped = count > max;
  const label = capped ? `${max}+` : String(count);
  const wide = capped || label.length > 1;

  return (
    <span
      className={cn(
        "inline-flex h-[1.125rem] shrink-0 items-center justify-center rounded-full text-[10px] font-semibold leading-none tabular-nums",
        wide ? "min-w-[1.125rem] px-1.5" : "w-[1.125rem]",
        variant === "solid"
          ? "bg-[var(--mail-accent)] text-white"
          : "bg-[var(--mail-accent-soft)] text-[var(--mail-accent)]",
        className
      )}
      aria-label={`${capped ? `Plus de ${max}` : count} non lu${count > 1 ? "s" : ""}`}
    >
      {label}
    </span>
  );
}
